import Vue from "vue";

import {
  SET_PAGE,
  TOGGLE_SEARCH_FACET_VALUE,
  SET_SEARCH_FACET_VALUE,
  UNSET_SEARCH_FACET_VALUE,
  CLEAR_FACET,
  SET_YEAR_OF_ENTRY,
  SET_SOLR_AVAILABLE,
} from "@/js/search/store/mutations";

import { mapGetters, mapState } from "vuex";

import trackingHelper from "@/js/search/mixins/trackingHelper";

const TrackingPlugin = Vue.extend({
  mixins: [trackingHelper],
  computed: {
    ...mapGetters(["pageForUi", "query", "totalHits"]),
    ...mapState({
      facets: ({ search }) => search.facets,
    }),
  },
  watch: {
    query(newQuery, oldQuery) {
      if (newQuery !== oldQuery) {
        this.trackQuery(newQuery);
      }
    },
    totalHits(total) {
      if (total === 0) {
        this.trackNoResults(this.query);
      }
    },
  },
  created() {
    this.$store.subscribe(this.mutationHandler);
  },
  methods: {
    isFacetApplied({ name, value }) {
      return this.facets[name] && this.facets[name].indexOf(value) > -1;
    },
    mutationHandler({ type, payload }) {
      let result;
      switch (type) {
        // change page
        case SET_SOLR_AVAILABLE:
          if (payload === false) {
            result = this.trackSolrError();
          }
          break;
        case SET_PAGE:
          result = this.trackGoResultPage(this.pageForUi);
          break;
        case SET_YEAR_OF_ENTRY:
          result = this.trackChangeYearOfEntry(payload);
          break;
        // facets
        case SET_SEARCH_FACET_VALUE:
        case TOGGLE_SEARCH_FACET_VALUE:
          result = this.isFacetApplied(payload)
            ? this.trackAddFacet(this.getFacetLabel(payload))
            : this.trackRemoveFacet(this.getFacetLabel(payload));
          break;
        case UNSET_SEARCH_FACET_VALUE:
        case CLEAR_FACET:
          result = this.trackRemoveFacet(this.getFacetLabel(payload));
          break;
        default:
          break;
      }
      return result;
    },
    getFacetLabel: ({ name, value }) => (value ? `${name}: ${value}` : false),
  },
});

export default function initTrackingPlugin(store) {
  /* eslint-disable no-param-reassign */
  store.trackingPlugin = new TrackingPlugin({ store });
}
